var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "control-bar py-2 d-flex align-center"
  }, [!_vm.isSelfServe ? _c('div', {
    staticClass: "d-flex align-center pl-3"
  }, [_vm.hasManyCampaigns ? _c('div', {
    staticClass: "mr-3"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('controlbar_campaign')))]), _c('span', {
    staticClass: "value font-weight-bold pl-1"
  }, [_vm._v(_vm._s(_vm.campaignName))])]) : _vm._e(), _c('div', {
    staticClass: "mr-3"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('controlbar_products_affected')))]), _c('span', {
    staticClass: "value font-weight-bold pl-1"
  }, [_vm._v(_vm._s(_vm.productCount))])])]) : _vm._e(), _vm.editor.default_language ? _c('div', {
    class: {
      'pl-3': _vm.isSelfServe
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('reference_language')) + ": ")]), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c('span', _vm._g(_vm._b({
          staticClass: "value font-weight-bold pl-1 pointer",
          on: {
            "click": _vm.openLanguageModal
          }
        }, 'span', attrs, false), on), [_vm._v(" " + _vm._s(_vm.$t("languages_".concat(_vm.editor.default_language))) + " ")])];
      }
    }], null, false, 4049179284)
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('translations_change_reference_language')))])])], 1) : _vm._e(), _c('v-spacer'), !_vm.hideUpdateButton ? _c('div', {
    staticClass: "d-flex align-center segmented-button-ctn"
  }, [_vm.hasPublishedVersion && _vm.hasUnpublishedChanges && !_vm.publishing && !_vm.saving ? _c('info-tooltip', {
    staticClass: "more-tooltip ml-3",
    attrs: {
      "compact": true,
      "color": "#f9ad61",
      "position": "left",
      "content": _vm.$t('controlbar_changes_saved')
    }
  }) : _vm._e(), _c('v-btn', {
    staticClass: "font-weight-black update-btn",
    class: {
      'has-addon': _vm.hasPublishedVersion && _vm.hasUnpublishedChanges
    },
    attrs: {
      "color": "primary",
      "small": "",
      "disabled": _vm.publishing || _vm.saving || !_vm.hasUnpublishedChanges && !_vm.needToUpdateRedirection
    },
    on: {
      "click": _vm.publish
    }
  }, [_vm.saving ? _c('span', [_vm._v(_vm._s(_vm.$t('saving')))]) : _vm._e(), _vm.publishing && !_vm.hasPublishedVersion ? _c('span', [_vm._v(_vm._s(_vm.$t('publishing')))]) : _vm._e(), _vm.publishing && _vm.hasPublishedVersion ? _c('span', [_vm._v(_vm._s(_vm.$t('updating')))]) : _vm._e(), !_vm.publishing && !_vm.saving && !_vm.hasPublishedVersion ? _c('span', [_vm._v(_vm._s(_vm.$t('publish')))]) : _vm._e(), !_vm.publishing && !_vm.saving && _vm.hasPublishedVersion ? _c('span', [_vm._v(_vm._s(_vm.$t('update')))]) : _vm._e()]), _vm.hasPublishedVersion && _vm.hasUnpublishedChanges ? _c('v-menu', {
    attrs: {
      "bottom": "",
      "offset-y": "",
      "nudge-left": "190",
      "nudge-bottom": "1"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref2) {
        var on = _ref2.on;
        return [_c('v-btn', _vm._g({
          staticClass: "drop-down-btn ma-0 pa-0 mr-4",
          attrs: {
            "small": "",
            "disabled": _vm.publishing || _vm.saving
          }
        }, on), [_c('v-icon', [_vm._v("$drop-down")])], 1)];
      }
    }], null, false, 27356207)
  }, [_c('v-list', {
    staticClass: "ma-0 pa-0"
  }, [_c('v-list-item', {
    staticClass: "pt-0 pb-0",
    on: {
      "click": _vm.openRestorePopup
    }
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-light text-caption"
  }, [_vm._v(_vm._s(_vm.$t('controlbar_restore_last_published')))])], 1)], 1)], 1) : _vm._e()], 1) : _vm._e(), _c('v-dialog', {
    attrs: {
      "width": "500"
    },
    model: {
      value: _vm.restoreModal,
      callback: function callback($$v) {
        _vm.restoreModal = $$v;
      },
      expression: "restoreModal"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.$t('controlbar_restore_last_published_question')))]), _c('v-card-text', {
    staticClass: "py-4"
  }, [_vm._v(" " + _vm._s(_vm.$t('controlbar_restore_warning')) + " ")]), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function click($event) {
        _vm.restoreModal = false;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('cancel')))]), _c('v-btn', {
    attrs: {
      "color": "red",
      "disabled": _vm.restoring,
      "text": ""
    },
    on: {
      "click": _vm.restorePublishedVersion
    }
  }, [_vm._v(_vm._s(_vm.$t('confirm')))])], 1)], 1)], 1), _c('language-edit-modal', {
    attrs: {
      "show-go-to-translations": true
    },
    model: {
      value: _vm.languageModal,
      callback: function callback($$v) {
        _vm.languageModal = $$v;
      },
      expression: "languageModal"
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }